"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CONGRATS_SCREEN = void 0;
exports.CREDIT_BUILDER_CONGRATS_SCREEN = {
    HEADER: 'Congrats!',
    CTA: 'Finish',
    BODY: 'You’re ready to boost your credit! Each month, Flex will automatically pay your rent and send reports, beginning with your {{firstBpMonth}} bill. Check your email for more info.'
};
